module.exports = __webpack_public_path__ + "img/2020.05.418d07ec.png";